import type { Message } from "@/types/chat";

import { cleanMarkdown, isMarkdown } from "@/utils/markdownUtils";

export const getPendingRequestId = (messages: Message[]): string | null => {
  const last = messages[messages.length - 1];
  return last?.sender === "ai" && last?.isLoading === true ? last.id : null;
};

/**
 * Process the message text to remove choice indicators and clean markdown if needed
 */
export const processMessageText = (text: string): string => {
  if (!text) return "";

  const cleanedText = text.replace(/→\s*(\[[^\]]+\]\s*)+/g, "").trim();

  if (isMarkdown(cleanedText)) {
    return cleanMarkdown(cleanedText);
  }

  return cleanedText;
};
